import { AgentSurfaceId, AgentOverlayState } from "@/store/agent-overlay/types";
import { AgentActivitiesPage } from "@/pages/agent/agent-activities-page";
import { AgentActivityPage } from "@/pages/agent/agent-activity-page";
import { AgentOverviewPage } from "@/pages/agent/agent-overview-page";
import { AgentProjectPage } from "@/pages/agent/agent-project-page";
import { AgentProjectsPage } from "@/pages/agent/agent-projects-page";
import { AgentTaskPage } from "@/pages/agent/agent-task-page";
import { AgentTasksPage } from "@/pages/agent/agent-tasks-page";

interface AgentOverlayContentProps {
  activeSurface: AgentOverlayState;
}

export const AgentOverlayContent = ({ activeSurface }: AgentOverlayContentProps) => {
  switch (activeSurface.surfaceId) {
    case AgentSurfaceId.Overview:
      return <AgentOverviewPage />;
    case AgentSurfaceId.Projects:
      return <AgentProjectsPage />;
    case AgentSurfaceId.Project:
      return <AgentProjectPage projectId={activeSurface.projectId} />;
    case AgentSurfaceId.Tasks:
      return <AgentTasksPage />;
    case AgentSurfaceId.Task:
      return <AgentTaskPage taskId={activeSurface.taskId} />;
    case AgentSurfaceId.Activities:
      return <AgentActivitiesPage />;
    case AgentSurfaceId.Activity:
      return <AgentActivityPage activityId={activeSurface.activityId} />;
    default:
      return <AgentOverviewPage />;
  }
};
